import './allCategoriesList.css';

var styles = {"allCategoriesListWrapper":"allCategoriesListWrapper__29DUY","allCategoriesListContainer":"allCategoriesListContainer__c6sT4","en-us":"en-us__3ZmSg","allCategoriesColumn":"allCategoriesColumn__2hd8U","aci":"aci__1usIT","aciParent":"aciParent__6ihtY","aciChildWrap":"aciChildWrap__RDnbr","aciChild":"aciChild__11A8e","pageOverlay":"pageOverlay__2k_De","allCategoriesListWrapperCategoryPage":"allCategoriesListWrapperCategoryPage__gN906"};

export { styles as default };
